module.exports = __webpack_public_path__ + "static/media/Golden.d7392f77.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Golden.jpg
 ** module id = 400
 ** module chunks = 0
 **/